<template>
  <MainLayout section="about" v-bind:no_footer="true">
    <div id="about_content">
      <div id="about_text" v-bind:class="$mq">
        <h1 class="content_header"><b>xrpintel</b><br/>XRP Intelligence<sup style='font-size: 0.4em;'> (beta)</sup></h1>
  
        <p>
        xrpintel is an <a href="https://en.wikipedia.org/wiki/Ripple_(payment_protocol)">XRP</a> network monitor and analyzer.
        </p>
  
        <p>
        The core application offers a scalable mechanism through which to <b>follow the XRP Ledger</b> and track
        </p>
  
        <ul style="list-style-type: none; padding-left: 0">
          <li><b>Accounts</b></li>
          <li><b>Transactions</b></li>
          <li><b>Payments</b></li>
          <li><b>Offers/Markets</b></li>
          <li><b>Network Status</b></li>
          <li><b>& More</b></li>
        </ul>
  
        <p>
        Embeded is an <b>extensible statistical framework</b> through which the XRP Ledger-Based BlockChain is analyzed.
        </p>
  
        <!--<p>
        Additional research can be found <b><a href="https://xrpintel.com/research">here</a></b>.
        </p>-->
  
        <p style="margin-top: 50px">
        You may support project development via the following XRP address:
        </p>
  
        <p style="font-size: 0.8em; margin-bottom: 0">
        <b>rhkvfNv6tzh6CMfpXZdX2t7HGN2ZX46Tco</b>
        </p>
  
        <div id="about_tipbot">
          <a amount="5.00" size="175" to="DevNullProd" network="twitter" href="https://www.xrptipbot.com" target="_blank"></a>
        </div>

        <br/>

        <br/>
        <p id="disclaimer">
        xrpintel data and services are provided without any warranties or guarantees of any kind. Dev Null Productions takes no responsibility for how the software and metrics provided here, via twitter, or any other distribution channel are used. By accessing and/or using this information all users expressly and implicitly agree to aboslve Dev Null Productions of all &amp; any legal and financial liabilities or claims arising from, out of, or in connection with this software and/or data or use or other dealings in this software and/or data.
        </p>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout     from './components/MainLayout.vue'

export default {
  name: 'About',

  components: {
    MainLayout,
  },

  mounted : function(){
    var script = document.createElement("script");
    script.setAttribute('src', 'https://www.xrptipbot.com/static/donate/tipper.js');

    var div = document.getElementById('about_tipbot'); 
    div.appendChild(script);
  }
}
</script>

<style scoped>
#about_content{
  flex-grow: 1;
  text-align: center;
  background-image: url('./assets/world.gif');
  background-size: 100% 100%;
  color: white;
  display: flex;
  align-items: stretch;
}

#about_text{
  flex-grow: 1;
  padding-top: 100px;
  opacity: 0.8;
  background-color: #0a0a0a;
}

#about_text.sm{
  padding-left: 10px;
  padding-right: 10px;
}

#about_tipbot{
  margin-top: 25px;
}

#disclaimer{
   width: 75%;
   margin: auto;
   border-top: 1px solid white;
   padding-top: 10px;
   font-size: 0.7em;
}
</style>
